/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'backgrounds/click-tip-shape': {
    width: 236,
    height: 91,
    viewBox: '0 0 236 91',
    data: '<g filter="url(#filter0_d)" _fill="#fff"><rect pid="0" x=".208" y="4" width="227.365" height="62.429" rx="31.215"/><path pid="1" d="M6.374 53.326v33.527l16.185-21.966 1.542-4.239-17.727-7.322z"/></g><defs><filter id="filter0_d" x=".208" y="0" width="235.365" height="90.853" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/><feOffset dx="4"/><feGaussianBlur stdDeviation="2"/><feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/><feBlend in2="BackgroundImageFix" result="effect1_dropShadow"/><feBlend in="SourceGraphic" in2="effect1_dropShadow" result="shape"/></filter></defs>'
  }
})
